import { render, staticRenderFns } from "./ResourcePage.vue?vue&type=template&id=26c1a72e&scoped=true"
import script from "./ResourcePage.vue?vue&type=script&lang=js"
export * from "./ResourcePage.vue?vue&type=script&lang=js"
import style0 from "./ResourcePage.vue?vue&type=style&index=0&id=26c1a72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c1a72e",
  null
  
)

export default component.exports